module.exports = __webpack_public_path__ + "static/media/4.5da979d8.jpg";